var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDecoStarBlueTt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 165.341,
    height: 165.341,
    viewBox: "0 0 165.341 165.341",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Exclude",
    opacity: 0.05,
    d: "M91.3203 0C93.2942 0 94.8945 1.60037 94.8945 3.57422V51.8906L120.749 26.0361C121.419 25.3659 122.328 24.9893 123.276 24.9893C124.224 24.9893 125.133 25.3659 125.804 26.0361L137.64 37.873C139.035 39.2688 139.035 41.5321 137.64 42.9277L110.12 70.4463H161.767C163.74 70.4463 165.341 72.0467 165.341 74.0205V91.3203C165.341 93.2939 163.74 94.8945 161.767 94.8945H112.055L136.24 119.081C137.636 120.477 137.636 122.74 136.24 124.136L124.404 135.972C123.009 137.367 120.745 137.367 119.35 135.972L94.8945 111.517V161.767C94.8943 163.74 93.294 165.341 91.3203 165.341H74.0205C72.0468 165.341 70.4466 163.74 70.4463 161.767V110.12L44.5918 135.975C43.1961 137.37 40.9328 137.37 39.5371 135.975L27.7012 124.139C26.3055 122.743 26.3057 120.48 27.7012 119.084L51.8906 94.8945H3.57422C1.60054 94.8945 0.000263903 93.2939 0 91.3203V74.0205C0 72.0467 1.60037 70.4463 3.57422 70.4463H53.8252L26.3047 42.9268C25.6346 42.2566 25.2579 41.3471 25.2578 40.3994C25.2578 39.4517 25.6346 38.5423 26.3047 37.8721L38.1406 26.0361C39.5363 24.6404 41.7996 24.6404 43.1953 26.0361L70.4463 53.2871V3.57422C70.4463 1.60037 72.0467 0 74.0205 0H91.3203Z",
    fill: "#5170FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecoStarBlueTt);
export default __webpack_public_path__ + "static/media/deco-star-blue-tt.69d6803056cadd8dc325a5bb0177c036.svg";
export { ForwardRef as ReactComponent };